<template>
	<v-card class="mb-2">
		<v-card-text>
			<v-layout row wrap>
				<v-flex xs12 md2 class="font-weight-bold text-right pr-2">
					Paciente:
				</v-flex>
				<v-flex xs12 md10>
					{{ datosPaciente.Nombres }}
					{{ datosPaciente.PrimerApellido }}
					{{ datosPaciente.SegundoApellido }}
				</v-flex>
				<v-flex xs12 md2 class="font-weight-bold text-right pr-2">
					Fecha Nacimiento:
				</v-flex>
				<v-flex xs12 md2>
					{{ datosPaciente.FechaNacimiento }}
				</v-flex>
				<v-flex xs12 md2 class="font-weight-bold text-right pr-2">
					Edad:
				</v-flex>
				<v-flex xs12 md2> {{ datosPaciente.Edad }} a. </v-flex>
				<v-flex xs12 md2 class="font-weight-bold text-right pr-2">
					Núm. Exp.
				</v-flex>
				<v-flex xs12 md2>
					{{ datosPaciente.NumExp }}
				</v-flex>
				<v-flex xs12 md2 class="font-weight-bold text-right pr-2">
					Fecha Actual:
				</v-flex>
				<v-flex xs12 md2>
					{{ datosPaciente.FechaActual }}
				</v-flex>
				<v-flex xs12 md2 class="font-weight-bold text-right pr-2">
					Hora:
				</v-flex>
				<v-flex xs12 md2>
					{{ datosPaciente.HoraActual }}
				</v-flex>
			</v-layout>
		</v-card-text>
	</v-card>
</template>

<script>
export default {
	name: "datosGenerales",
	props: ["datosPaciente"]
};
</script>
